<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3">
			<button-search ref="buttonSearch" placeholder="搜索游客昵称" @search="searchEvent" :showGj="true">
				<!-- 左边 -->
				<template #left>
					<!-- <el-button class="mr-2"  @click="openModel(false)" type="primary" size="mini" 
					v-auth="'add'+auth_val">添加背景</el-button>
					<el-button type="danger" v-auth="'del'+auth_val" @click="deleteAll" size="mini">批量删除</el-button> -->

				</template>

				<!-- 高级搜索 1-->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="游客昵称" class="mb-0">
							<el-input size="small" v-model="from.name" placeholder="搜索ID"></el-input>
						</el-form-item>
					
					
						<el-form-item label="客户端" class="mb-0">
							<el-select v-model="from.client" size="small" placeholder="请选择查看类型">
								<el-option label="全部" :value="0"></el-option>
								<el-option label="H5" value="h5"></el-option>
								<el-option label="安卓" value="android"></el-option>
								<el-option label="IOS" value="ios"></el-option>
								<el-option label="PC" value="pc"></el-option>
							</el-select>
						</el-form-item>
						
						


						

						<!-- <el-form-item label="最后登录时间" size="small" class="mb-0">
							<el-date-picker v-model="from.login_time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
							 range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
							</el-date-picker>
						</el-form-item> -->

						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜索 </el-button>
							<el-button size="small" @click="clearSearch">清空筛选条件</el-button>
						</el-form-item>

					</el-form>
				</template>
			</button-search>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" @sort-change="sortChange" border style="width: 100%" @selection-change="handleSelectionChange">
				<!-- <el-table-column type="selection" width="45" align="center">

				</el-table-column> -->
				<el-table-column fixed align="center" type="index" label="排序" width="50">
				</el-table-column>
				<el-table-column fixed align="center" sortable="custom" prop="id"  label="ID">
				</el-table-column>
			
				<el-table-column align="center" prop="tourists_code" label="手机唯一码" min-width="120">
				</el-table-column>
				
				
				
				
				<el-table-column align="center" prop="tourists_nick" label="游客昵称" min-width="120">
				</el-table-column>
				
				<el-table-column align="center" prop="phone" label="绑定手机号" min-width="120">
				</el-table-column>
				<el-table-column align="center" prop="client" label="客户端">
				</el-table-column>
				

		

				<!-- <el-table-column sortable="custom" align="center" prop="addtime"  label="注册时间">
				</el-table-column>
				 -->
<!-- 				<el-table-column prop="id" fixed="right" align="center" width="160" label="操作">
					<template slot-scope="scope">
						<el-button-group>
							<el-button v-auth="'edit'+auth_val" size="mini" plain type="primary" @click="openModel(scope.row,3)">编辑</el-button>
							<el-button v-auth="'edit'+auth_val" size="mini" plain type="success" @click="checkUserMt(scope.row)">查看MT4</el-button>

						</el-button-group>
					</template>
				</el-table-column> -->
			</el-table>
		</div>


		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
			<!-- 底部 -->

			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>



		<el-dialog title="修改用户" :visible.sync="createModel" top="5vh">
			<!-- 表单内容 -->
			<el-form :rules="rules" ref="form" :model="form" label-width="100px">

				<el-form-item label="用户ID:" prop="">
					{{form.id}}
				</el-form-item>
				<el-form-item label="ArenaID:" prop="">
					{{form.u_id}}
				</el-form-item>
				<el-form-item label="邮箱:" prop="">
					{{form.username}}
				</el-form-item>
				<el-form-item label="钱包余额:" prop="">
					{{form.money}}
				</el-form-item>


				<el-form-item v-show="form.type==3" label="昵称" prop="name">
					<el-input v-model="form.name" placeholder="昵称" clearable size="small" style="width: 34%;"></el-input>
				</el-form-item>
				<el-form-item v-show="form.type==3" label="电话" prop="phone">
					<el-input v-model="form.phone" placeholder="电话" clearable size="small" style="width: 34%;"></el-input>
				</el-form-item>
				<el-form-item v-show="form.type==3" label="地址" prop="location">
					<el-input v-model="form.location" placeholder="地址" clearable size="small" style="width: 34%;"></el-input>
				</el-form-item>

				<el-form-item v-show="form.type==3" label="性别">
					<el-radio-group v-model="form.sex" size="small">
						<el-radio :label="0" border>未选择</el-radio>
						<el-radio :label="1" border>男</el-radio>
						<el-radio :label="2" border>女</el-radio>
					</el-radio-group>
				</el-form-item>

				<el-form-item v-show="form.type==3" label="生日" prop="birthday">
					<el-date-picker v-model="form.birthday" type="date" placeholder="选择日期">
					</el-date-picker>
				</el-form-item>

				<el-form-item v-show="form.type==3" label="新密码" prop="password">
					<el-input v-model="form.password" placeholder="无需修改密码此处留空" clearable size="small" style="width: 34%;"></el-input>
				</el-form-item>
				<el-form-item v-show="form.type==3" label="确认密码" prop="password">
					<el-input v-model="form.password2" placeholder="确认密码" clearable size="small" style="width: 34%;"></el-input>
				</el-form-item>

			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">确 定</el-button>
			</div>
		</el-dialog>

		<el-dialog title="查看用户MT4信息" :visible.sync="checkModel" top="5vh">
			<!-- 表单内容 -->
			<el-form :rules="rules" ref="form" :model="form" label-width="100px">

				<el-form-item label="邮箱:" prop="">

					<el-button type="primary" plain>{{mt_info.email}}</el-button>
				</el-form-item>
				<el-form-item v-show="mt_info['is_have']==1" label="唯一ID:" prop="">
					<el-button type="primary" plain>{{mt_info.list.reqid}}</el-button>
				</el-form-item>
				<el-form-item v-show="mt_info['is_have']==1" label="登录账号:" prop="">
					<el-button type="primary" plain>{{mt_info.list.login}}</el-button>
				</el-form-item>
				<el-form-item v-show="mt_info['is_have']==1" label="杠杆率:" prop="">
					<el-button type="primary" plain>{{mt_info.list.leverage}}</el-button>
				</el-form-item>
				<el-form-item v-show="mt_info['is_have']==1" label="登录密码:" prop="">
					<el-button type="primary" plain>{{mt_info.list.password}}</el-button>
				</el-form-item>
				<el-form-item v-show="mt_info['is_have']==1" label="投资者密码:" prop="">
					<el-button type="primary" plain>{{mt_info.list.investor}}</el-button>
				</el-form-item>
				<el-form-item v-show="mt_info['is_have']==1" label="分组:" prop="">
					<el-button type="primary" plain>{{mt_info.list.groupname}}</el-button>
				</el-form-item>
				<div style="text-align: center;" v-show="mt_info['is_have']==0">

					<el-button type="danger" plain>用户还没有MT4账号!</el-button>
				</div>


			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="checkModel = false">关 闭</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout'],
		mixins: [common],
		data() {
			return {
				createModel: false,
				checkModel: false,
				editIndex: -1,
				//搜索数据
				from: {
					name: '',
					client: 0,


				},
				model_title: '背景',
				auth_val: 'User',
				preUrl: "user/userList", //列表地址
				delAllUrl: "user/delUserAll", //批量删除地址
				delUrl: "user/delUser", //删除单条地址
				addUrl: "user/addUser", //添加/修改地址
				editStatusUrl: "user/editStatusUser", //修改状态地址

				tableData: [],
				form: {
					headUrl: '',
					headId: 0,
					phone: '',
					id: 0,
					u_id: "",
					money: 0,
					username: '',
					name: '',
					location: '',
					sex: 0,
					birthday: '',
					password: "",
					password2: "",
				},
				prop: 'id',
				sort: 'descending',
				rules: {
					name: [{
							required: true,
							message: "昵称不能为空",
							trigger: 'blur',
						},

					]
				},
				rule_list: [],
				check_img_list: [],
				mt_info: {
					is_have: 0,
					list: {}
				}
			}
		},
		watch: {
			activeName(e) {
				console.log(e);
			}
		},
		created() {
			//this.commonList('rule');
		},
		methods: {
			sortChange(column) {

				this.prop = column.prop
				this.sort = column.order
				this.getList()
			},
			//提交
			submit() {
				if (this.form.password != this.form.password2) {
					this.$message({
						message: '两次密码输入不一致',
						type: 'error'
					});
					return
				}
				this.$refs.form.validate(res => {
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 关闭模态框
					}
				})
			},

			checkUserMt(item) {
				this.checkModel = true

				this.api.post('/user/userMtInfo', {
					id: item.id,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.mt_info = list
					this.mt_info.email = item.username
					console.log(this.mt_info)
				}).catch(err => {
					// 失败
				})
			},


			checkUserMoney(item, index) {
				this.$set(this.tableData[index], 'is_check', 1)
				this.api.post('/user/userMoney', {
					id: item.id,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.$set(this.tableData[index], 'is_check', 2)
					this.$set(this.tableData[index], 'mt_money', list)


				}).catch(err => {
					// 失败
				})
			},

			// 打开模态框
			openModel(e, type) {
				// 修改
				this.form = {
					headUrl: e.head,
					headId: 0,
					phone: e.phone,
					id: e.id,
					u_id: e.u_id,
					money: e.money,
					num: 0,
					name: e.name,
					username: e.username,
					sex: e.sex,
					birthday: e.birthday,
					location: e.location,
					type: type,
					password: "",
					password2: "",
				}

				this.editIndex = e.id
				// 打开dialog
				this.createModel = true
			},

			//公共列表

			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				console.log(this.tableData)
				this.check_img_list = e.list.map(item => {
					return item.head
				})
			},
			// 清空筛选条件
			clearSearch() {
				this.from = {
					name: '',
					client: 0,
				}

				this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
		}
	}
</script>

<style>
</style>
